import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import { jsx as _jsx } from "react/jsx-runtime";
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    width: 20,
    height: 14,
    fill: "none",
    viewBox: "0 0 20 14",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M1.538 2.044c-.14-.392-.31-.66-.506-.803C.842 1.098.497 1.027 0 1.027V0h5.39v1.027c-.811 0-1.287.056-1.429.168-.14.112-.209.233-.202.364.006.13.04.292.101.485l2.598 8.633L9.793 0H11l3.399 10.64 2.533-8.596a1.49 1.49 0 0 0 .046-.392c0-.156-.113-.299-.34-.43-.222-.13-.688-.195-1.4-.195V0H20v1.027c-.46 0-.814.077-1.06.233-.245.15-.426.41-.543.784L14.62 14h-1.198L10.014 3.78 6.734 14H5.656L1.538 2.044z",
      fill: "#fff"
    })
  }));
};
export default SvgComponent;